export const ROLE = {
  superadmin: 'superadmin',
  admin: 'admin',
  readonly: 'readonly',
  mobileapp: 'mobileapp',
  user: 'user',
};
